import styled from "styled-components";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const Container = styled(Stack)`
    width: 100%;
    gap: 16px;
`;

export const Header = styled(Flex)`
    align-items: center;
    gap: 10px;
`;

export const ItemsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
`;

export const ButtonContainer = styled.div`
    margin-left: auto;
`;
